import { Modal } from '@mui/material';
import React from 'react';
import { ActionButton } from '../../common/ActionButton';
import styles from './styles.module.scss';

type Props = {
  isCancelModalOpen: boolean;
  onCancel: () => void;
  setIsCancelModalOpen: React.Dispatch<React.SetStateAction<boolean>>;
};

export const CancelModal: React.FC<Props> = ({
  isCancelModalOpen,
  onCancel,
  setIsCancelModalOpen,
}) => {
  return (
    <Modal open={isCancelModalOpen} onClose={() => setIsCancelModalOpen(false)}>
      <div className={styles.modalContent}>
        <div className={styles.modalTitle}>利用をキャンセル</div>
        <div className={styles.modalDescription}>
          利用をキャンセルしてもよろしいですか？キャンセル後のこの操作の取り消しはできません。
        </div>
        <div className={styles.btnContainer}>
          <ActionButton
            content='キャンセル'
            className={styles.addBtn}
            action={() => setIsCancelModalOpen(false)}
          />
          <ActionButton
            content='キャンセルする'
            type='dark'
            className={styles.addBtn}
            action={onCancel}
          />
        </div>
      </div>
    </Modal>
  );
};
